import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const DEFAULT_CONFIG = {
    pendingFallback: null,
    renderError: () => {
        throw new Error('No renderError configured in BoundaryConfigProvider or passed by Boundary props');
    },
};
export const createConfigProvider = ({ contextDisplayName = 'BoundaryConfigContext' }) => {
    const Context = createContext(DEFAULT_CONFIG);
    Context.displayName = contextDisplayName;
    function BoundaryConfigProvider({ pendingFallback, renderError, onErrorCaught, children }) {
        const config = useMemo(() => ({ pendingFallback, renderError, onErrorCaught }), [pendingFallback, renderError, onErrorCaught]);
        return (_jsx(Context.Provider, { value: config, children: children }));
    }
    function useBoundaryConfig() {
        return useContext(Context);
    }
    return {
        BoundaryConfigProvider,
        useBoundaryConfig,
    };
};
//# sourceMappingURL=config.js.map